import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-close.tsx
/**
* icon.24.close
*
* Keywords: cross, x, dismiss, cancel, delete, remove
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjIyNCA3LjA4MmEuNTAxLjUwMSAwIDAgMSAuNjk0LjY5M2wtLjA2NS4wNzhMMTIuNzA3IDEybDQuMTQ2IDQuMTQ2LjA2NS4wNzhhLjUuNSAwIDAgMS0uNjk0LjY5NGwtLjA3OC0uMDY1TDEyIDEyLjcwNmwtNC4xNDcgNC4xNDdhLjUuNSAwIDEgMS0uNzA3LS43MDdsNC4xNDctNC4xNDctNC4xNDctNC4xNDYtLjA2NC0uMDc4YS41MDEuNTAxIDAgMCAxIC42OTMtLjY5M2wuMDc4LjA2NEwxMiAxMS4yOTNsNC4xNDYtNC4xNDd6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-605
*/
const Icon24Close = memo(function Icon24Close(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.224 7.082a.501.501 0 0 1 .694.693l-.065.078L12.707 12l4.146 4.146.065.078a.5.5 0 0 1-.694.694l-.078-.065L12 12.706l-4.147 4.147a.5.5 0 1 1-.707-.707l4.147-4.147-4.147-4.146-.064-.078a.501.501 0 0 1 .693-.693l.078.064L12 11.293l4.146-4.147z"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M16.854 7.146a.5.5 0 0 1 0 .707L12.707 12l4.147 4.146a.5.5 0 0 1-.708.707L12 12.708l-4.146 4.147a.5.5 0 1 1-.708-.708L11.293 12 7.146 7.854a.5.5 0 0 1 .708-.708L12 11.293l4.146-4.147a.5.5 0 0 1 .708 0",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Close };

//# sourceMappingURL=icon-24-close.js.map